<img [ngClass]="imgClass" [src]="qrUrl" [alt]="imgAlt" />
